import LandingPage from "@/pages/Landing";

export default [
  {
    path: "/500",
    name: "Forbidden",
    component: LandingPage,
    props: { mode: "forbidden" }
  },
  {
    path: "/404",
    name: "NotFound",
    component: LandingPage,
    props: { mode: "notFound" }
  },
  {
    path: "*",
    redirect: "/404"
  }
];
